import { useEffect, useState } from "react"
import Form from 'react-bootstrap/Form'

import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"

import * as Basic from "../../../Modules/BasicFields"

const tournamentVariables = [
    {name:'Output', key:'output', type:'W'},
    {name:'First pick', key:'pick_1', type:'W'},
    {name:'Second pick', key:'pick_2', type:'W'}
]

export default function Tournament( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected
    const reset = props.reset

    const [ joinHashtag, setJoinHashtag ] = useState(null)
    const [ actionHashtag, setActionHashtag ] = useState(null)

    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)

    const requiredData = [
        joinHashtag,
        actionHashtag,
        font,
        variables
    ]

    const cfgName = "kingmaker_tournament_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setJoinHashtag( cfg.join_hashtag || "" )
        setActionHashtag( cfg.action_hashtag || "")

        setFont( cfg.font || {})
        setVariables( cfg.variables || {})
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font 
        data.variables = variables

        data.join_hashtag = joinHashtag
        data.action_hashtag = actionHashtag
       
        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ joinHashtag, actionHashtag, font, variables ])

    if( requiredData.includes(null) )
    {
        return (<></>)
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.StringInput name="Join Hashtag" value={joinHashtag} setValue={setJoinHashtag}/>
                <Basic.StringInput name="Action Hashtag" value={actionHashtag} setValue={setActionHashtag}/>
            </SettingsGroup>

            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={tournamentVariables}
                            reset={reset}
            />
        </>
    )
}

